import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import {func, object, string} from 'prop-types';
import React, {useCallback} from 'react';

export default function SortOrder({onChange, value, sx}) {
  const onChangeInternal = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <RadioGroup onChange={onChangeInternal} value={value} sx={sx}>
      <FormControlLabel
        value="false"
        control={<Radio sx={{height: 20}} />}
        label={<Typography sx={{fontSize: 'small'}}>most relevant</Typography>}
      />
      <FormControlLabel
        value="true"
        control={<Radio sx={{height: 20}} />}
        label={<Typography sx={{fontSize: 'small'}}>most recent</Typography>}
        sx={{marginTop: 1}}
      />
    </RadioGroup>
  );
}

SortOrder.propTypes = {
  onChange: func.isRequired,
  value: string,
  sx: object,
};
